export const emailRegex = new RegExp(
  "[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$"
);
export const ifscRegex = new RegExp("^[A-Za-z]{4}[a-zA-Z0-9]{7}$");
export const mobileRegex = new RegExp("^[6-9]{1}[0-9]{9}$");
export const nameRegex = new RegExp("^[a-zA-Z ]{4,50}$");
export const accountRegex = new RegExp("^[a-zA-Z ]{0,10}$");
export const panRegex = new RegExp("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$");
export const bankAccountRegex = new RegExp("^[0-9]{9,18}$");
export const pincodeRegex = /^[A-Za-z0-9]+$/;
export const countryCodeRegex = new RegExp("^[+][0-9]{1,3}$");
export const alphabetsRegex = new RegExp("/^[A-Za-z]$/");
export const isOnlyNumber = (value) => /^\d+$/.test(value);

export const otpRegex = /^\d{6}$/;

export const drivingLicenseRegex = /^[A-Za-z0-9]+$/;
export const passportNumberRegex = /^[A-Za-z0-9]+$/;
export const nomineePanRegex = new RegExp("^([a-zA-Z]){3}([pPtT]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$");



export const genderOptions = [
  { name: "Male", value: "M" },
  { name: "Female", value: "F" },
  { name: "Others", value: "O" },
];
export const NomineesList = [
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
  {
    label: "3",
    value: "3",
  },
];

export const categoryOptions = [
  { name: "Resident Indian", value: "11" },
  { name: "NRI", value: "20" },
];
export const statusOptions = [
  { name: "Individual", value: "I" },
  { name: "NRI", value: "N" },
];
export const Occupations = [
  { label: "Service", value: 1 },
  { label: "Business", value: 2 },
  { label: "Student", value: 3 },
  { label: "House Wife", value: 4 },
  { label: "Professional", value: 5 },
  { label: "Retired", value: 7 },
  { label: "Others", value: 8 },
];
export const Gross_Annual_income = [
  { label: "Below 1 Lac", value: "Below 1 Lac" },
  { label: "1-5 Lacs", value: "1-5 Lacs" },
  { label: "5-10 Lacs", value: "5-10 Lacs" },
  { label: "10-25 Lacs", value: "10-25 Lacs" },
  { label: "25 Lacs-1 Crore", value: "25 Lacs-1 Crore" },
  { label: "1 Crore and above", value: "1 Crore and above" },
];

export const modeOfHoldingOptions = [
  { name: "Single", value: "single" },
  { name: "Anyone (or) survivor", value: "anyone" },
];

export const countrycodeOptions = [
  { label: "+91", value: "+91" },
  { label: "+61", value: "+61" },
  { label: "+1", value: "+1" },
  { label: "+852", value: "+852" },
  { label: "+968", value: "+968" },
  { label:"+974", value: "+974" },
  { label:"+966", value: "+966"},
  { label: "+65", value: "+65" },
  { label: "+971", value: "+971" },
  {label: "+44", value: "+44"}
];

export const relationshipOptions = [
  {
    name: "Brother",
    value: "Brother",
  },
  {
    name: "Daughter",
    value: "Daughter",
  },
  {
    name: "Father",
    value: "Father",
  },
  {
    name: "Mother",
    value: "Mother",
  },
  {
    name: "Sister",
    value: "Sister",
  },
  {
    name: "Son",
    value: "Son",
  },
  {
    name: "Wife",
    value: "Wife",
  },
];
export const familyDescriptionOptions = [
  {
    label: "Self",
    value: "SE",
  },
  {
    label: "Spouse",
    value: "SP",
  },
  {
    label: "Dependent Children",
    value: "DC",
  },
  {
    label: "Dependent Siblings",
    value: "DS",
  },
  {
    label: "Dependent Parents",
    value: "DP",
  },
  {
    label: "Guardian",
    value: "GD",
  },
];
